export default __webpack_public_path__ + "static/media/gia-emblem.f30a3a54.png";